import Filterable from '@ui/Filterable'
import { createGuest } from '@client/utils'

export const STATUS_PENDING = 0

export const STATUS_CONFIRMED = 1

export const STATUS_DECLINED = 2

export type GuestStatus =
	| typeof STATUS_PENDING
	| typeof STATUS_CONFIRMED
	| typeof STATUS_DECLINED

export default class Guest implements Filterable {
	constructor(
		public id: number,
		public user_id: number,
		public name: string,
		public status: number,
		public dietary_requirements: string,
		public created_at: string,
	) {}

	public getFilterName = (): string => {
		return 'guest'
	}

	public reset = (): Filterable => {
		return createGuest()
	}

	public toFilter = (): any => {
		return {
			name: this.name,
			user_id: this.user_id,
		}
	}
}
